// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Yqwsy","option":"styles_option__eL1eH","active":"styles_active__2snCp"};